import { useState } from 'react'
import Heading from 'components/heading/heading'
// import { get } from 'utils/api'
import Checkbox from 'components/input/checkbox/checkbox'
import { cn, parseFormEvent } from 'utils/helpers'
import Infoblock from 'components/infoblock/infoblock'
import styles from './product-features.module.scss'
import { default as featuresData } from 'utils/data/features'

export default function ProductFeatures({ item, onChange, forProduct }) {
    const selected = item.features || []
    const [features] = useState(featuresData)

    // const init = async () => {
    //     const results = await get('features/1')
    //     setFetures(results.data.data.features)
    // }

    const handleChange = e => {
        const { name, value } = parseFormEvent(e)
        if (value) {
            onChange({ name: 'features', value: [...selected, name] })
        } else {
            onChange({ name: 'features', value: selected.filter(slug => slug !== name) })
        }
    }

    // useEffect(init, [])

    return (
        <div>
            {!forProduct && (
                <Heading size="18" tag="h2" className="mb30">
                    Kokias savybes atitinka VISOS jūsų prekės?
                </Heading>
            )}
            {!!forProduct && (
                <Checkbox
                    name="standard_features"
                    className={styles.check}
                    value={item.standard_features}
                    onChange={onChange}
                    label="Bendros prekių savybės"
                    info="Pažymėjus šį laukelį bus naudojamos bendros prekių savybės, nurodytos parduotuvės nustatymų puslapyje."
                />
            )}
            {(!forProduct || !item.standard_features) && (
                <>
                    <Infoblock className="mb30">
                        Tyrimai rodo, kad kuo aiškiau yra iškomunikuotos produkto pridėtinės vertės, tame tarpe ir jų
                        etiškumo aspektas, tuo lengviau pirkėjui apsispręsti dėl prekių įsigijimo. Pažymėjus savybes,
                        nepamirškite jų paminėti ir plačiau papasakoti prekės ir parduotuvės aprašymuose. Taip jūsų
                        parduotuvė bus skaidresnė, o pirkėjams informacija apie prekes bus aiškesnė.
                        {!forProduct && (
                            <>
                                <br />
                                <br />
                                Individualioms prekėms savybes galėsite nurodyti atskirai.
                            </>
                        )}
                        <br />
                        <br />
                        Pasirinkite iki 5 savybių.
                    </Infoblock>
                    <div className={cn(styles.list, 'mb36')}>
                        {features.map(feature => (
                            <Checkbox
                                key={feature.slug}
                                name={feature.slug}
                                value={selected.includes(feature.slug)}
                                onChange={handleChange}
                                description={feature.description}
                                label={
                                    <>
                                        <b>{feature.name}</b> {feature.explain && <span>({feature.explain})</span>}
                                    </>
                                }
                            />
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}
